const label =
{
    created  : "Créé {0}",
    modified : "Modifié {0}",
    unknown  : 'Inconnu'
};

export default label ;
